module.exports = __webpack_public_path__ + "img/parque_automotor_hover.ab55ad62.png";